import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { APICONSTANTS } from "../../constants/api-constants";
import { SsDomaineModel } from "../../models/simple-types/ss-domaine.model";
import { GenericLibelleService } from "../basic/generic-libelle.service";
import { HostnameService } from "../basic/hostname.service";

@Injectable()
export class SsDomaineService extends GenericLibelleService<SsDomaineModel> {
    constructor(http: HttpClient,
                protected toastrService: ToastrService,
                protected hostnameService: HostnameService) {
        super(http, toastrService, APICONSTANTS.ROUTESSDOMAINE, hostnameService);
  }
}
